module.exports = __webpack_public_path__ + "static/media/eyeLotion2.b322a48f.jpg";